/* eslint-disable-next-line import/prefer-default-export */
export const ConfigSection = {
  FORMAT: 'format',
  MODEL_INPUT_DATE_FILTERS: 'model_input_date_filters',
};
